<template>
  <div>
    <div class="new-header">
      <div class="header-desktop">
        <div class="pdv-container h-full only-desktop">
          <div class="new-header2 h-full w-full">
            <div class="logo-header">
              <a href="/" class="logo-link">
                <img
                  src="/images/featured/nuevo-logo.svg"
                  class="pdv-logo-new"
                  alt="logo-new-header"
                />
              </a>
            </div>
            <div class="content-header">
              <div class="header-item">
                <router-link
                  :to="{ name: 'Landing' }"
                  class="header-item-link"
                  :class="{ active: currentRouteName == 'Landing' }"
                >
                  Home
                </router-link>
              </div>
              <div class="header-item">
                <a
                  href="https://www.preupdv.cl/"
                  target="_blank"
                  class="header-item-link"
                >
                  Preuniversitario PDV
                </a>
              </div>
              <div class="header-item">
                <a
                  href="https://www.preupdv.cl/sedes"
                  target="_blank"
                  class="header-item-link"
                >
                  Sede
                </a>
              </div>
              <div class="header-item">
                <a
                  href="https://www.preupdv.cl/contacto"
                  target="_blank"
                  class="header-item-link"
                >
                  Contacto
                </a>
              </div>
              <!-- <div class="header-item">
                <a href="https://ventaonline.preupdv.cl/packpdv" target="_blank" class="header-item-link">
                  Outlet
                </a>
              </div> -->
            </div>
            <div class="button-header h-full">
              <p class="text-header">Si necesitas ayuda, llámanos</p>
              <button
                class="extra-boton text-nowrap"
                @click="handleClick"
                style="
                  outline: 5px solid rgba(12, 11, 11, 0.25);
                  border: 1px solid white;
                "
              >
                <a href="tel:6005002020">
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="call-icon"
                  />
                </a>
                600 500 2020
              </button>
            </div>
          </div>
        </div>

        <!-- Menú móvil -->
        <div
          class="container-menu-mobile h-full only-mobile flex items-center justify-between px-4"
        >
          <div class="logo-header-mobile flex-shrink-0">
            <a href="/">
              <img
                src="/images/featured/nuevo-logo.svg"
                class="h-10 w-auto"
                alt="logo-mobile"
              />
            </a>
          </div>

          <div class="hamburguesa-container">
            <img
              :src="
                mobileMenuShow
                  ? '/images/featured/close-circle-menu.svg'
                  : '/images/featured/menu-icon.svg'
              "
              :alt="mobileMenuShow ? 'Cerrar menú' : 'Abrir menú'"
              @click="openMobileMenu"
              class="cursor-pointer h-8 w-auto"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Menú móvil desplegable -->
    <div
      class="menu-mobile"
      id="menu-mobile"
      :class="{ open: mobileMenuShow }"
      v-show="mobileMenuShow"
    >
      <ul>
        <li>
          <img
            src="/images/featured/home-menu.svg"
            class=""
            alt="logo-mobile"
          />
          <a
            href="https://ventaonline.preupdv.cl/"
            class="d-flex fs-md-16 header-link-mobile"
          >
            Home
          </a>
        </li>
        <li>
          <img
            src="/images/featured/teacher-menu.svg"
            class=""
            alt="logo-mobile"
          />
          <a
            href="https://www.preupdv.cl/"
            target="_blank"
            class="d-flex fs-md-16 header-link-mobile"
          >
            Preuniversitario PDV
          </a>
        </li>
        <li>
          <img
            src="/images/featured/location-menu.svg"
            class=""
            alt="logo-mobile"
          />
          <a
            href="https://www.preupdv.cl/sedes"
            target="_blank"
            class="d-flex fs-md-16 header-link-mobile"
          >
            Sede
          </a>
        </li>
        <li>
          <img
            src="/images/featured/call-menu.svg"
            class=""
            alt="logo-mobile"
          />
          <a
            href="https://www.preupdv.cl/contacto"
            target="_blank"
            class="d-flex fs-md-16 header-link-mobile"
          >
            Contacto
          </a>
        </li>
        <!-- <li>
          <img src="/images/featured/price-tag.svg" class="w-8 h-8" alt="logo-mobile">
          <a href="https://ventaonline.preupdv.cl/packpdv" target="_blank" class="d-flex fs-md-16 header-link-mobile">
            Outlet
          </a>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import Button from "@/components/featured/Button";
export default {
  components: {
    Button,
  },
  data() {
    return {
      mobileMenuShow: false,
      currentPage: null,
      discount: null,
    };
  },
  computed: {
    backpackVisible() {
      return this.$store.state.backpackVisible;
    },

    studentsWithPrices() {
      return this.$store.state.studentsWithPrices;
    },
    currentRouteName() {
      return this.$route.name;
    },
  },

  watch: {
    currentPage(newVal) {
      if (newVal === "Step3") {
        this.$store.dispatch("setStudentsWithPrices");
      }
    },
  },

  props: {
    showBackpack: {
      default: true,
    },
    showPromoMessage: {
      default: true,
    },
    hideHeader: {
      default: false,
    },
    improveGradesHeader: {
      default: false,
    },
  },
  mounted() {
    this.currentPage = this.$route.name;
  },
  methods: {
    handleClick() {},
    goTo(slug) {
      document.body.style.overflow = "visible";
      if (slug !== "#") {
        this.$router.push({ name: slug });
      }
    },
    openMobileMenu() {
      this.mobileMenuShow = !this.mobileMenuShow;

      if (this.mobileMenuShow) {
        document.body.style.overflow = "hidden"; // Evita el scroll cuando el menú está abierto
      } else {
        document.body.style.overflow = ""; // Restaura el comportamiento normal del scroll
      }
    },
    closeMobileMenu() {
      document.body.style.overflow = "visible";
      this.mobileMenuShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pdv-logo-new {
  width: 190px;
  padding: 8%;
}

.only-mobile {
  display: flex; /* Asegura que los elementos estén en línea */
  align-items: center;
  width: 100%; /* Ocupa todo el ancho disponible */
  padding: 10px 16px;
}

/* Asegura que el logo NO se encoja */
.logo-header-mobile {
  flex-shrink: 0;
}

.logo-header-mobile img {
  display: block;
  height: 40px; /* Ajusta la altura */
  width: auto;
}

/* Empuja el icono de hamburguesa a la derecha */
.hamburguesa-container {
  margin-left: auto;
}

.hamburguesa-container img {
  display: block;
  height: 30px;
}

.extra-boton {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $colorTerciario;
  border: solid 5px $neutralwhite;
  color: $neutralwhite;
  height: 35px;
  margin-bottom: 10px;
  padding: 16px 16px;
  img {
    margin-right: 16px;
  }
}

.new-header {
  position: relative;
  z-index: 10000;
  background: $amarrillo50;
}
.header-desktop {
  @media (max-width: 768px) {
    height: 80px;
  }
  @media (min-width: 769px) {
    height: 80px;
    border-bottom: solid 2px $neutralBlack;
  }

  .new-header2 {
    display: flex;
    @media (max-width: 768px) {
    }
    @media (min-width: 769px) {
      padding: 0 76px;
    }
    .logo-header {
      width: 180px;
    }

    .content-header {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      gap: 24px;

      .header-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        .header-item-link {
          padding: 8px 16px;
          color: $neutralBlack;
          font-family: "Poppins-Medium", sans-serif;
          font-size: 16px;
          line-height: 24px;
          &:hover {
            border-radius: 16px;
            background: $amarrillo30;
          }
          &.active {
            border-radius: 16px;
            background: $amarrillo30;
          }
        }
      }
    }

    .button-header {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      justify-content: flex-end;
    }
    .text-header {
      white-space: nowrap;
      font-size: 15px;
      margin-bottom: 6px;
      font-weight: bold;
      @include alternative-regular();
      letter-spacing: -0.23px;
      line-height: 22px;
      color: #000;
      text-align: center;
    }
  }
}

.container-menu-mobile {
  display: flex;
  padding: 0 24px 0 36px;

  .hamburguesa-container {
    display: flex;
    align-items: center;
  }
}

.mobile-menu {
  background: #000;
  position: fixed;
  right: 0;
  width: 70%;
  padding: 37px 15px;
  box-shadow: -3px 5px 9px 2px #00000075;
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      text-align: right;
      margin-bottom: 28px;
      &:last-child {
        margin-bottom: 0;
      }
      a {
        color: #fff;
        text-decoration: underline;
        font-size: 13px;
        line-height: 17px;
        @include alternative-regular;
        &:hover {
          color: #fff;
        }
      }
    }
  }
}

.backpack-float-number-container {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #000;
  background: #fff;
  left: -3px;
  top: 6px;
  .backpack-float-number {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @include alternative-bold;
    color: #000;
  }
}
hr {
  height: 0.25rem;
  width: 25%;
  margin: 0;
  background: $black;
  border: none;
  transition: 0.3s ease-in-out;
}
.tel-link {
  @include alternative-bold;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.28px;
  line-height: 22px;
  text-align: right;
  @include media-breakpoint-down(sm) {
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.3px;
  }
  &:before {
    content: url("/images/svgs/telefono.svg");
    width: 18px;
    height: 18px;
    left: 0;
    margin-right: 8px;
  }
}
.ham-menu {
  margin-right: 35px;
  height: 24px;
  width: 24px;
  padding: 6px 3px 6px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .line {
    &:nth-child(1) {
      margin-bottom: 2px;
    }
    &:nth-child(2) {
      margin-bottom: 2px;
    }
    width: 18px;
    height: 2px;
    background: #000;
  }
}
.menu-mobile {
  width: 0;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  right: 0;
  z-index: 100;
  background: $amarrillo50;
  transition: 0.5s all ease-in-out;

  ul {
    text-align: left;
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 19px 0;
      margin-left: 24px;
      display: flex;
      align-items: center;

      img {
        margin-right: 16px;
      }

      a {
        color: $neutralBlack;
        font-family: "Poppins-Medium", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }
}
.open {
  width: 100%;
  position: absolute;
  top: 76px;
  bottom: 0;
  transition: 0.5s all ease-in-out;
}
.w-20 {
  width: 20%;
}
.recomend-course-header {
  font-size: 34px;
  line-height: 40px;
  letter-spacing: -0.43px;
  text-align: left;
  opacity: 0.9;
  display: flex;
  margin-bottom: 0;
  color: #000;
  @include Gotham-Black;
  @include media-breakpoint-down(md) {
    font-size: 18px;
    letter-spacing: -0.22px;
    line-height: 20px;
    margin-left: 42px;
  }
  @include media-breakpoint-down(sm) {
    width: 312px;
  }
  @media screen and (max-width: 768px) {
    margin-left: 0;
  }
  @media screen and (max-width: 430px) {
    margin-left: 42px;
  }
  @media screen and (max-width: 320px) {
    margin-left: 20px;
    display: inline-flex;
    flex-wrap: nowrap;
    width: auto;
  }
}
.recomend-course-sub-header {
  font-size: 25px;
  letter-spacing: -0.3px;
  line-height: 50px;
  margin-bottom: 0;
  color: #000;
  @include Gotham-Book;
  @include media-breakpoint-down(md) {
    font-size: 15px;
    letter-spacing: -0.18px;
    line-height: 20px;
    opacity: 0.9;
  }
  @include media-breakpoint-down(md) {
    margin-left: 42px;
  }
  @media screen and (max-width: 768px) and (min-width: 600px) {
    margin-left: 0 !important;
  }
  @media screen and (max-width: 320px) {
    margin-left: 20px;
    display: inline-flex;
    flex-wrap: nowrap;
    width: auto;
  }
}
.header-mobile-container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.header-link-home {
  color: $black;
  margin-bottom: 5px;
  &:hover {
    text-decoration: none;
    color: $black;
  }
  @include alternative-regular();
  font-size: 16px;
  letter-spacing: -0.23px;
  line-height: 22px;
}
.header-link-home-container {
  margin: 0 27.5px;
  &:first-child {
    margin-left: 35px;
    margin-right: 27.5px;
  }
}
.labeler {
  height: 5px;
  width: 100%;
  background-color: #000000;
}
.left-simbol {
  position: absolute;
  top: -33px;
  left: -190px;
  width: 297px;
  height: 239px;
  opacity: 0.5;
  @include media-breakpoint-down(sm) {
    left: -140px;
  }
}
.header-steps {
  max-width: 1270px;
  .logo {
    @include media-breakpoint-down(md) {
      img {
        position: relative;
        z-index: 100;
        height: 60px;
        width: 60px;
      }
      display: flex;
      margin-left: 42px;
    }
    @include media-breakpoint-down(sm) {
      img {
        width: 60px;
      }
    }
  }
}
.text-header-container {
  align-self: center;
  @include media-breakpoint-down(sm) {
    width: 100%;
    // justify-content: center;
    // align-items: center;
  }
}
.link-tel-container {
  display: none;
  @include media-breakpoint-down(md) {
    display: flex;
    margin-right: 33px;
  }
}

.logo-mobile-container {
  margin-bottom: 22px;
}
.middle-simbol {
  position: absolute;
  left: 42%;
  top: 0;
  width: auto;
  height: auto;
  z-index: 0;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}
.last-simbol {
  position: absolute;
  right: 11%;
  top: -150px;
  width: auto;
  height: auto;
  z-index: 0;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}
.header-link-mobile {
  @include alternative-regular();
  font-size: 16px;
  letter-spacing: -0.23px;
  line-height: 22px;
  color: #000;
  text-align: center;
  &:hover {
    color: #000;
  }
}
.no-margingx {
  margin-right: 0px !important;
  margin-left: 0px !important;
}
.logo-header {
  .logo-link {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>